// src/components/ContaCorrenteModal.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from './Button';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
`;

const FormGroup = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: bold;
`;

const Input = styled.input`
  /* width: 100%; */
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
`;

const InutilizacaoModal = ({ isOpen, onClose, onSave }) => {
  const [numero, setNumero] = useState('');
  const [serie, setSerie] = useState('');
  const [justificativa, setJustificativa] = useState('');

  const handleSubmit = () => {
    onSave({
      numero,
      serie,
      justificativa
    });
  };

  return (
    <ModalOverlay isOpen={isOpen}>
      <ModalContent>
        {/* <h3>Inutilização de Numero</h3> */}
        <FormGroup>
          <Label>Informe o número / série</Label>
          <div style={{ display: 'flex' }}>
            <Input style={{ maxWidth: '80%' }} placeholder='123456' value={numero} onChange={e => setNumero(e.target.value)} />
            <Input style={{ maxWidth: '20%' }} placeholder='0' value={serie} onChange={e => setSerie(e.target.value)} />
          </div>
        </FormGroup>
        <FormGroup>
          <Label>Justificativa</Label>
          <Input style={{ width: '100%' }} value={justificativa} onChange={e => setJustificativa(e.target.value)} />
        </FormGroup>
        <ButtonRow>
          <Button variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button variant="primary" onClick={handleSubmit}>Enviar</Button>
        </ButtonRow>
      </ModalContent>
    </ModalOverlay>
  );
};

export default InutilizacaoModal;
